import store from '@/store'

function getCurrentUserID() {
    return store.state.currentUserID
}

function getUserIsAuth() {
    return store.getters.getUserIsAuth
}

export { getCurrentUserID, getUserIsAuth }